module.exports = __webpack_public_path__ + "static/img/logo-gosell.97fb389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-gosell.png
// module id = 8T9i
// module chunks = 134